<section>
    <!-- Start Banner Area -->
    <div class="rbt-banner-area rbt-banner-8 variation-02">
        <div class="container">
            <div class="row g-5 align-items-center">
                <div class="col-lg-12 offset-lg-1">
                    <div class="content">
                        <div class="inner text-center">
                            <div class="rbt-new-badge rbt-new-badge-one">
                                <span class="rbt-new-badge-icon">🏆</span> {{'bestOnline' | translate}}
                            </div>

                            <h1 class="title">{{'knowMoreAbout' | translate}}
                                <span class="header-caption">
                                    <span class="cd-headline clip is-full-width">
                                        <span class="cd-words-wrapper">
                                            <b class="is-visible theme-gradient">{{'Ourmission' | translate}}.</b>
                                            <b class="is-hidden theme-gradient">{{'vision' | translate}}.</b>
                                            <b class="is-hidden theme-gradient">{{'plans' | translate}}.</b>
                                        </span>
                                    </span>
                                </span>
                            </h1>
                            <p class="description has-medium-font-size mt--20">{{'startLearning' | translate}}
                            </p>
                            <div class="slider-btn rbt-button-group justify-content-center" *ngIf="!tokenValid">
                                <a class="rbt-btn btn-gradient hover-transform-none" >
                                    <span class="icon-reverse-wrapper" routerLink="/login">
                                        <span class="btn-text">{{'Login' | translate}}</span>
                                        <span class="btn-icon"><i class="feather-arrow-left"></i></span>
                                        <span class="btn-icon"><i class="feather-arrow-left"></i></span>
                                    </span>
                                </a>
                                <a class="rbt-btn hover-icon-reverse btn-white" routerLink="/contact">
                                    <span class="icon-reverse-wrapper">
                                        <span class="btn-text" routerLink="/contact">{{'Contact Us' | translate}}</span>
                                        <span class="btn-icon"><i class="feather-arrow-left"></i></span>
                                        <span class="btn-icon"><i class="feather-arrow-left"></i></span>
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End Banner Area -->

    <!-- Start Video Area  -->
    <div class="rbt-video-area">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="video-popup-wrapper glightbox" style="box-shadow: 0px 6px 34px rgba(215, 216, 222, 0.41);">
                        <img class="w-100 rbt-radius" src="./../../../assets/images/about.jpeg" alt="Video Images">
                        <a class="rbt-btn rounded-player-2 popup-video position-to-top with-animation btn-theme-color" >
                            <span class="play-icon"></span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- <div class="glightbox">
        Play video
    </div> -->
    <!-- End Video Area  -->

    <!-- Start Service Area -->
    <div class="rbt-service-area bg-color-white rbt-section-gap">
        <div class="container">
            <div class="row mb--60">
                <div class="col-lg-12">
                    <div class="section-title text-center">
                        <h2 class="title">{{'howToStart' | translate}}</h2>
                        <p class="description mt--30">{{'getExper' | translate}}.</p>
                    </div>
                </div>
            </div>
            <!-- Start Card Area -->
            <div class="row row--15 mt_dec--30">

                <!-- Start Service Grid  -->
                <div class="col-lg-4 col-xl-3 col-xxl-3 col-md-6 col-sm-6 col-12 mt--30">
                    <div class="service-card service-card-6">
                        <div class="inner">
                            <div class="icon">
                                <img src="assets/images/icons/001-bulb.png" alt="icons Images">
                            </div>
                            <div class="content">
                                <h6 class="title"><a  style="cursor: default;">{{'reg' | translate}}</a></h6>
                                <p class="description">{{'regToStart' | translate}}</p>
                            </div>
                            <span class="number-text">1</span>
                        </div>
                    </div>
                </div>
                <!-- End Service Grid  -->

                <!-- Start Service Grid  -->
                <div class="col-lg-4 col-xl-3 col-xxl-3 col-md-6 col-sm-6 col-12 mt--30">
                    <div class="service-card service-card-6">
                        <div class="inner">
                            <div class="icon">
                                <img src="assets/images/icons/002-hat.png" alt="Shape Images">
                            </div>
                            <div class="content">
                                <h6 class="title"><a style="cursor: default;">{{'enrollment' | translate}}</a></h6>
                                <p class="description">{{'enrollStart' | translate}}</p>
                            </div>
                            <span class="number-text">2</span>
                        </div>
                    </div>
                </div>
                <!-- End Service Grid  -->

                <!-- Start Service Grid  -->
                <div class="col-lg-4 col-xl-3 col-xxl-3 col-md-6 col-sm-6 col-12 mt--30">
                    <div class="service-card service-card-6">
                        <div class="inner">
                            <div class="icon">
                                <img src="assets/images/icons/003-id-card.png" alt="Shape Images">
                            </div>
                            <div class="content">
                                <h6 class="title"><a style="cursor: default;">{{'start' | translate}}</a></h6>
                                <p class="description">{{'startCourse' | translate}}</p>
                            </div>
                            <span class="number-text">3</span>
                        </div>
                    </div>
                </div>
                <!-- End Service Grid  -->

                <!-- Start Service Grid  -->
                <div class="col-lg-4 col-xl-3 col-xxl-3 col-md-6 col-sm-6 col-12 mt--30">
                    <div class="service-card service-card-6">
                        <div class="inner">
                            <div class="icon">
                                <img src="assets/images/icons/004-pass.png" alt="Shape Images">
                            </div>
                            <div class="content">
                                <h6 class="title"><a style="cursor: default;">{{'finish' | translate}}</a></h6>
                                <p class="description">{{'finishAll' | translate}}</p>
                            </div>
                            <span class="number-text">4</span>
                        </div>
                    </div>
                </div>
                <!-- End Service Grid  -->

            </div>
            <!-- End Card Area -->
        </div>
    </div>
    <!-- End Service Area -->

    <!-- <div class="rbt-team-area bg-gradient-7 rbt-section-gap">
        <div class="container">
            <div class="row mb--60 g-5 align-items-end">
                <div class="col-lg-8 col-md-6 col-12">
                    <div class="section-title text-start">
                        <span class="subtitle bg-white-opacity">أفضل المعلمين</span>
                        <h2 class="title color-white">أكثر المعلمين تقييماً على المنصة</h2>
                    </div>
                </div>
            </div>
            <div class="row g-5">

                
                <div class="col-lg-3 col-md-6 col-sm-6 col-12">
                    <div class="rbt-team-modal-thumb nav nav-tabs">
                        <a class="rbt-team-thumbnail" href="javascript:void(0)" data-bs-toggle="modal" data-bs-target="#exampleModal">
                            <div class="thumb">
                                <img src="assets/images/team/team-05.jpg" alt="Testimonial Images">
                            </div>
                        </a>
                    </div>
                </div>
                

                
                <div class="col-lg-3 col-md-6 col-sm-6 col-12">
                    <div class="rbt-team-modal-thumb nav nav-tabs">
                        <a class="rbt-team-thumbnail" href="javascript:void(0)" data-bs-toggle="modal" data-bs-target="#exampleModal">
                            <div class="thumb">
                                <img src="assets/images/team/team-09.jpg" alt="Testimonial Images">
                            </div>
                        </a>
                    </div>
                </div>
                

                
                <div class="col-lg-3 col-md-6 col-sm-6 col-12">
                    <div class="rbt-team-modal-thumb nav nav-tabs">
                        <a class="rbt-team-thumbnail" href="javascript:void(0)" data-bs-toggle="modal" data-bs-target="#exampleModal">
                            <div class="thumb">
                                <img src="assets/images/team/team-03.jpg" alt="Testimonial Images">
                            </div>
                        </a>
                    </div>
                </div>
                

                
                <div class="col-lg-3 col-md-6 col-sm-6 col-12">
                    <div class="rbt-team-modal-thumb nav nav-tabs">
                        <a class="rbt-team-thumbnail" href="javascript:void(0)" data-bs-toggle="modal" data-bs-target="#exampleModal">
                            <div class="thumb">
                                <img src="assets/images/team/team-07.jpg" alt="Testimonial Images">
                            </div>
                        </a>
                    </div>
                </div>
                

                
                <div class="col-lg-2 col-md-3 col-sm-4 col-12">
                    <div class="rbt-team-modal-thumb nav nav-tabs">
                        <a class="rbt-team-thumbnail" href="javascript:void(0)" data-bs-toggle="modal" data-bs-target="#exampleModal">
                            <div class="thumb">
                                <img src="assets/images/team/team-01.jpg" alt="Testimonial Images">
                            </div>
                        </a>
                    </div>
                </div>
                

                
                <div class="col-lg-2 col-md-3 col-sm-4 col-12">
                    <div class="rbt-team-modal-thumb nav nav-tabs">
                        <a class="rbt-team-thumbnail" href="javascript:void(0)" data-bs-toggle="modal" data-bs-target="#exampleModal">
                            <div class="thumb">
                                <img src="assets/images/team/team-02.jpg" alt="Testimonial Images">
                            </div>
                        </a>
                    </div>
                </div>
                

                
                <div class="col-lg-2 col-md-3 col-sm-4 col-12">
                    <div class="rbt-team-modal-thumb nav nav-tabs">
                        <a class="rbt-team-thumbnail" href="javascript:void(0)" data-bs-toggle="modal" data-bs-target="#exampleModal">
                            <div class="thumb">
                                <img src="assets/images/team/team-04.jpg" alt="Testimonial Images">
                            </div>
                        </a>
                    </div>
                </div>
                

                
                <div class="col-lg-2 col-md-3 col-sm-4 col-12">
                    <div class="rbt-team-modal-thumb nav nav-tabs">
                        <a class="rbt-team-thumbnail" href="javascript:void(0)" data-bs-toggle="modal" data-bs-target="#exampleModal">
                            <div class="thumb">
                                <img src="assets/images/team/team-06.jpg" alt="Testimonial Images">
                            </div>
                        </a>
                    </div>
                </div>
                

                
                <div class="col-lg-2 col-md-3 col-sm-4 col-12">
                    <div class="rbt-team-modal-thumb nav nav-tabs">
                        <a class="rbt-team-thumbnail" href="javascript:void(0)" data-bs-toggle="modal" data-bs-target="#exampleModal">
                            <div class="thumb">
                                <img src="assets/images/team/team-08.jpg" alt="Testimonial Images">
                            </div>
                        </a>
                    </div>
                </div>
                

                
                <div class="col-lg-2 col-md-3 col-sm-4 col-12">
                    <div class="rbt-team-modal-thumb nav nav-tabs">
                        <a class="rbt-team-thumbnail" href="javascript:void(0)" data-bs-toggle="modal" data-bs-target="#exampleModal">
                            <div class="thumb">
                                <img src="assets/images/team/team-10.jpg" alt="Testimonial Images">
                            </div>
                        </a>
                    </div>
                </div>
                

            </div>

            <div class="rbt-team-modal modal fade rbt-modal-default" id="exampleModal" tabindex="-1" aria-labelledby="exampleModal" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="rbt-round-btn" data-bs-dismiss="modal" aria-label="Close">
                                <i class="feather-x"></i>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="inner">
                                <div class="row g-5 row--30 align-items-center">
                                    <div class="col-lg-4">
                                        <div class="rbt-team-thumbnail">
                                            <div class="thumb">
                                                <img class="w-100" src="assets/images/team/team-09.jpg" alt="Testimonial Images">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-8">
                                        <div class="rbt-team-details">
                                            <div class="author-info">
                                                <h4 class="title">Mames Mary</h4>
                                                <span class="designation theme-gradient">English Teacher</span>
                                                <span class="team-form">
                                        <i class="feather-map-pin"></i>
                                        <span class="location">CO Miego, AD,USA</span>
                                                </span>
                                            </div>
                                            <p class="mb--15">You can run LearnyHome easily. Any School, University, College can be use this LearnyHome education template for their educational purpose. A university can be success you.</p>

                                            <p>Run their online leaning management system by LearnyHome education template any where and time.</p>
                                            <ul class="social-icon social-default mt--20 justify-content-start">
                                                <li><a href="https://www.facebook.com/">
                                                        <i class="feather-facebook"></i>
                                                    </a>
                                                </li>
                                                <li><a href="https://www.twitter.com">
                                                        <i class="feather-twitter"></i>
                                                    </a>
                                                </li>
                                                <li><a href="https://www.instagram.com/">
                                                        <i class="feather-instagram"></i>
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="https://www.linkdin.com/">
                                                        <i class="feather-linkedin"></i>
                                                    </a>
                                                </li>
                                            </ul>
                                            <ul class="rbt-information-list mt--25">
                                                <li>
                                                    <a ><i class="feather-phone"></i>+1-202-555-0174</a>
                                                </li>
                                                <li>
                                                    <a href="mailto:hello@example.com"><i
                                                class="feather-mail"></i>example@gmail.com</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="top-circle-shape"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->

    <div class="rbt-brand-area bg-color-white ptb--60">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-12 offset-lg-1">
                    <!-- <div class="section-title text-center mb--40">
                        <span class="small-title w-600">أبرز عملاء منصة ليرني أكاديمي</span>
                    </div>
                    <ul class="brand-list brand-style-3 justify-content-center justify-content-lg-between">
                        <li><a ><img src="assets/images/brand/brand-01.png" alt="Brand Image"></a></li>
                        <li><a ><img src="assets/images/brand/brand-02.png" alt="Brand Image"></a></li>
                        <li><a ><img src="assets/images/brand/brand-03.png" alt="Brand Image"></a></li>
                        <li><a ><img src="assets/images/brand/brand-05.png" alt="Brand Image"></a></li>
                        <li><a ><img src="assets/images/brand/brand-06.png" alt="Brand Image"></a></li>
                    </ul> -->
                </div>
            </div>
        </div>
    </div>
</section>
